import { fetchHistory, objectHistoryNames, objectHistorySelectors } from "../store/objectHistorySlice";
import BanHistoryTable from "../components/banHistoryTable";
import BanHistoryTableHeader from "../components/banHistoryTableHeader";
import EditingDataHistoryDialog from "../components/editingDataHistoryDialog";
import React from "react";
import { banSelectors } from "../store/banSlice";
import { connect } from "react-redux";
import { showModalMessage } from "../store/modalsSlice";

class BanHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return "Ban history";
  }

  renderTable(tableProps) {
    return <BanHistoryTable {...tableProps} />;
  }

  renderBeforeContent() {
    const objectData = this.props.selectedBanedDevices(this.props.id);
    const editedFields = this.props.getEditedFields();
    return (
      <BanHistoryTableHeader
        editedFields={editedFields}
        objectData={objectData}
      />
    );
  }

  getLoaderMessage() {
    return "Ban history loading...";
  }
}

const mapStateToProps = (state) => ({
  getEditedFields: () => objectHistorySelectors.banHistoryEditedFields(state),
  objectState: objectHistorySelectors.banHistory(state),
  selectedBanedDevices: (id) => banSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (banId) => fetchHistory(banId, objectHistoryNames.banHistory),
  showModalMessage: (title, text) => showModalMessage({ text, title }),
};

export default connect(mapStateToProps, actionCreators)(BanHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/banHistoryDialog.js